import { Component, HostBinding } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';
import { AppStore } from '@app/app.store';
import { TranslateService } from '@ngx-translate/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { ThemeService } from './core/services/container/theme.service';

@Component({
  selector: 'vfs-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // TODO: Study how to get this change from other component.
  @HostBinding('class') componentCssClass;

  constructor(
    appConfigService: AppConfigService,
    private themeService: ThemeService,
    private translate: TranslateService,
    private permissionService: NgxPermissionsService,
    private appStore: AppStore
  ) {
    this.componentCssClass = this.themeService.setTheme(appConfigService.get().theme.name);
    if (this.appStore.state.session.rights) {
      this.permissionService.flushPermissions();
      this.permissionService.loadPermissions(this.appStore.state.session.rights);
    }
    // TODO: Review this locale lang assigned
    if (this.appStore.state.session.locale) {
      this.translate.use(this.appStore.state.session.locale).subscribe();
    }
  }
}
